/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_gc_input_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`e.g. ATGCGCGCTA`)
};

const es_gc_input_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`p. ej. ATGCGCGCTA`)
};

const de_gc_input_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`z. B. ATGCGCGCTA`)
};

const nl_gc_input_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`bijv. ATGCGCGCTA`)
};

const fr_gc_input_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ex. ATGCGCGCTA`)
};

const it_gc_input_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`es. ATGCGCGCTA`)
};

const pt_br2_gc_input_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ex.: ATGCGCGCTA`)
};

const pt_gc_input_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`por ex. ATGCGCGCTA`)
};

const ja_gc_input_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`例: ATGCGCGCTA`)
};

const zh_gc_input_placeholder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`例如 ATGCGCGCTA`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const gc_input_placeholder = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.gc_input_placeholder(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("gc_input_placeholder", locale)
	if (locale === "en") return en_gc_input_placeholder(inputs)
	if (locale === "es") return es_gc_input_placeholder(inputs)
	if (locale === "de") return de_gc_input_placeholder(inputs)
	if (locale === "nl") return nl_gc_input_placeholder(inputs)
	if (locale === "fr") return fr_gc_input_placeholder(inputs)
	if (locale === "it") return it_gc_input_placeholder(inputs)
	if (locale === "pt-BR") return pt_br2_gc_input_placeholder(inputs)
	if (locale === "pt") return pt_gc_input_placeholder(inputs)
	if (locale === "ja") return ja_gc_input_placeholder(inputs)
	return zh_gc_input_placeholder(inputs)
};